import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Nav from "@/components/Nav";
import { scrollToSection } from "@/components/Nav";
import Footer from "@/components/Footer";
import Hero from "@/components/sections/Hero";
import Marquee from "@/components/sections/Marquee";
import NewListing from "@/components/sections/NewListing";
import AboutUs from "@/components/sections/AboutUs";
import PastListings from "@/components/sections/PastListings";
import MarketNews from "@/components/sections/MarketNews";
import Reviews from "@/components/sections/Reviews";
import Contact from "@/components/sections/Contact";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    const target = location.state && location.state.scrollTo;
    if (target) {
      // Clear the state so it doesn't re-trigger on back/refresh
      window.history.replaceState({}, document.title);
      // Two-pass scroll: sections (and images) can grow after mount, which leaves
      // Lenis with a stale scroll `limit` and clamps long scrolls short. Re-invoke
      // after layout settles to correct any undershoot.
      const timers = [
        setTimeout(() => scrollToSection(target), 400),
        setTimeout(() => scrollToSection(target), 1100),
      ];
      return () => timers.forEach(clearTimeout);
    }
  }, [location.state]);

  return (
    <div data-testid="home-page" className="min-h-screen bg-[#0A0A0A] grain">
      <Nav />
      <Hero />
      <Marquee />
      <NewListing />
      <AboutUs />
      <PastListings />
      <MarketNews />
      <Reviews />
      <Contact />
      <Footer />
    </div>
  );
}
